import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

interface AccountsSearch {
  /** Show archived accounts too; omitted when false. */
  archived?: boolean;
}

/** validateSearch: the "show archived" filter lives in the URL (shareable). */
function sanitizeAccountsSearch(search: Record<string, unknown>): AccountsSearch {
  return { archived: search.archived === true || search.archived === "true" ? true : undefined };
}

const AccountList = lazy(async () => {
  const m = await import("@/features/accounts/components/account-list");
  return { default: m.AccountList };
});

function AccountsPage() {
  return (
    <Suspense fallback={null}>
      <AccountList />
    </Suspense>
  );
}

export const accountsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/accounts",
  validateSearch: sanitizeAccountsSearch,
  component: AccountsPage,
});
